import { ActivityPluginRegistry } from "../../registry/ActivityPluginRegistry";
import { ActivityTaskCard } from "./ActivityTaskCard";

ActivityPluginRegistry.register({
  key: "2",
  matches: (item) => item.Entity === 2,
  Component: ActivityTaskCard
});
